<template>
  <vue-modal :key="refreshModal" :ref="modalId" :name="modalId" :clickToClose="false" :draggable="true" :scrollable="true" :adaptive="true"  @opened="loadData" :resizable="true" :width="modalWidth" :minHeight="500" :maxHeight="1550" :height="'auto'">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
            <div :class="isError ? 'form-group form-row text-danger' : 'form-group form-row text-success'">
                {{ modalReturnMessage }}
            </div>
            <div class="form-group form-row text-danger">
                {{ errorMessage }}
            </div>
            <div style="min-height: 50px;">
                <div class="form-group form-row">
                    <span class="pr-2">Select a file to upload</span>
                    <input ref="importWaveDataUpload" type="file" @change="onFileChange" />
                </div>
            </div>                
            <div class="pt-1">Current Options ({{ this.numberOfOptions }}): {{ currentOptions }}</div>            
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary ml-4" @click="importFile" :disabled="disableImport">
            <span>Import File</span>
            <span v-show="getModalLoading()" class="spinner-border spinner-border-sm"></span>
        </button>
        <button type="button" class="btn btn-primary ml-4" @click="closeModal">Close</button>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import AdminService from "../services/admin.service";
import QuestionService from "../services/question.service";
import ViewMixins from "../mixins/ViewMixins.vue";
import DataTableMixins from "../mixins/DataTableMixins.vue";

export default {
  name: "ImportValidOptions",
  mixins: [ViewMixins,DataTableMixins],
  components: {},
  data() {
    return {
      modalReturnMessage: "",
      errorMessage: "",
      isError: false,
      disableImport: false,
      
      importValidOptionsFile: "",
      refreshModal: true 
    };
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    onFileChange: function() {
      this.importValidOptionsFile = this.$refs.importWaveDataUpload.files[0];
    },
    async loadData(){
        this.modalReturnMessage = "";
    },
    closeModal(){
      this.modalReturnMessage = "";
      if (this.$refs[this.modalId] != null) {
        this.$refs[this.modalId].visible = false;
      }
      this.refreshModal = !this.refreshModal;
    },    
    async importFile() {
      this.$root.processServerRequest("Importing valid option data");
      this.setModalLoading(true);
      QuestionService.importValidOptions(this.importValidOptionsFile, this.questionId, this.importFileCallback, this);
    },
    importFileCallback: function(response) {
      this.$root.processServerResponse();
      this.setModalLoading(false);
      let statusCode = response.data.statusCode;
      this.modalReturnMessage = response.data.message;
      if (statusCode == 200 ) {
        AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 });
        this.$emit("imported");
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },

  },
  watch: {},
  props: {
    modalId: {
      type: String,
      default: "import-valid-options",
    },
    modalTitle: {
      type: String,
      default: "Import Valid Options",
    },
    modalWidth: {
      type: Number,
      default: 368,
    },
    numberOfOptions: {
      type: Number,
      default: 0,
    },
    questionId: {
      type: Number,
      default: 0,
    },
    currentOptions: {
      type: String,
      default: "None",
    },
  }
};
</script>
